import BUNDLE_QUANTITY_MODAL from '../actionTypes/BundleQuantityModalActionTypes';

const bundleQuantityModal = (payload) => ({
    type: BUNDLE_QUANTITY_MODAL,
    payload,
});

export default bundleQuantityModal;
